import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { FormControl, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { AppService } from '../../Services/app.service';
import { PmsLogsService } from './pms-logs.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-pms-logs',
  templateUrl: './pms-logs.component.html'
})

export class PmsLogsComponent implements OnInit {

  page = 1;
  rows = 25;
  totalUserCount: any = 0;
  title!: string;
  navMenuName: any;
  prev: any;
  next: any;
  userList: any;
  dailyLogList: any;
  activeUserCount: any;
  progressValue: any;
  common: any;
  href: any;
  userId: any;
  aceessMenuByRoute: any;
  filterValue = '';
  filterDate: any = [];
  userLogData: any = [];
  mailArray: any = [];
  userDetails: any = [];
  selectedDate: any = new Date();
  today = new Date();
  dataSource = new MatTableDataSource;
  displayedColumns: string[] = [ 'logsFilled', 'userEmail', 'userName', 'value'];
  pmsDate = this.selectedDate.toLocaleString('default', { month: 'long' }) + ' ' + this.selectedDate.getDate() + ', ' + this.selectedDate.getFullYear();
  maxDateForRange: any = new Date(this.today.setDate(this.today.getDate()));
  maxDateForRangeConverted = this.maxDateForRange.toLocaleString('default', { month: 'long' }) + ' ' + this.maxDateForRange.getDate() + ', ' + this.maxDateForRange.getFullYear();

  breadcrumbConfig: object = {
    lastLinkColor: '#5B616E',
    symbol: ' / ',
  };

  @ViewChild("paginator") customPaginator!: ElementRef;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  // @ViewChild(MatSort, { static: true }) sort!: MatSort;
  @ViewChild(MatSort) sort: MatSort;
  
  public config: PerfectScrollbarConfigInterface = {
    useBothWheelAxes: true, suppressScrollX: false, suppressScrollY: false
  };

  PmsDateForm: FormGroup = new FormGroup({
    "dtPmsDate": new FormControl('', { validators: [] })
  });

  constructor(
    private appService: AppService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private pmsLogsService: PmsLogsService
  ) { }

  ngOnInit(): void {
    this.appService.getTitle().subscribe((data) => {
      this.title = data;
      this.cdr.detectChanges();
    });
    this.href = this.router.url;
    this.userId = sessionStorage.getItem('id');
    this.Menuaccess();
    this.UserCount();
  }

  ngAfterViewInit() {
    const page = document.getElementById('paginator');
    this.dataSource.paginator = this.paginator;    
  }

  get f(): any {
    return this.PmsDateForm.controls;
  }

  getDate(date: any) {
    this.pmsDate = date.toLocaleString('default', { month: 'long' }) + ' ' + date.getDate() + ', ' + date.getFullYear();
    this.DailyLog();
  }

  prevPmsDate() {
    this.selectedDate.setDate(this.selectedDate.getDate() - 1);
    this.prev = new Date(this.selectedDate);
    this.pmsDate = this.prev.toLocaleString('default', { month: 'long' }) + ' ' + this.prev.getDate() + ', ' + this.prev.getFullYear();
    this.DailyLog();
  }

  nextPmsDate() {
    if (this.selectedDate > this.maxDateForRange || this.pmsDate == this.maxDateForRangeConverted) {
      return;
    }
    else {
      this.selectedDate.setDate(this.selectedDate.getDate() + 1);
      this.next = new Date(this.selectedDate);
      this.pmsDate = this.next.toLocaleString('default', { month: 'long' }) + ' ' + this.next.getDate() + ', ' + this.next.getFullYear();
      this.DailyLog();
    }
  }

  UserCount() {
    this.pmsLogsService.UserCount(this.filterValue, this.page - 1, this.rows).subscribe((res: any) => {
      if (res) {
        this.userList = res.userDetail;
        this.totalUserCount = res.TotalCount;
        this.DailyLog();
      }
    });
  }

  async DailyLog() {
    var todayDate = this.selectedDate.getFullYear() + '-' + String(this.selectedDate.getMonth() + 1).padStart(2, '0') + '-' + String(this.selectedDate.getDate()).padStart(2, '0');
    await this.pmsLogsService.DailyLog(todayDate).subscribe(async (res: any) => {
      if (res) {
        this.dailyLogList = await res;
        if (this.dailyLogList) {
          this.filterDate = []
          for (let i = 0; i < this.dailyLogList.length; i++) {
            if (this.dailyLogList[i].recordDate == this.pmsDate) {
              this.filterDate.push(this.dailyLogList[i]);
            }
          }
          if (this.userList.length > 0) {
            this.userList.map((ele) => {
              let index = this.filterDate.filter((item) => item.userEmail == ele.userEmail);
              let value = 0;
              if (index.length > 0) {
                index.map((element) => {
                  value = value + Number(element.value);
                });
                ele.value = value;
              }
            })
          }
          function getUniqueListBy(data, key) {
            return [...new Map(data.map(item => [item[key], item])).values()]
          }
          this.dataSource.data = await (this.userList);          
          this.dataSource.sort = await this.sort;
          let activeUser = getUniqueListBy(this.filterDate, 'userEmail')
          this.activeUserCount = activeUser.length;
          if (this.activeUserCount > 0) {
            this.progressValue = ((this.activeUserCount / this.totalUserCount) * 100);
          }
          else {
            this.progressValue = 0;
          }
        }
      }
      else {
        this.ngOnInit();
      }
    });
  }

  getUsersData(event: any) {
    this.page = event;
    this.UserCount();
    setTimeout(() => {
      this.DailyLog();
    }, 400);
  }

  applyFilter(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;
    this.UserCount();
    this.DailyLog();
  }

  sendMail() {
    this.DailyLog();
  }

  sendMailValue(event) {
    if (event.checked) {
      this.mailArray.push({ email: event.value })
    }
  }

  Menuaccess() {
    if (this.userId !== '') {
      this.pmsLogsService.listUserById(this.userId).subscribe(res => {
        this.userDetails = res['data'].UserMenuAccesses;
        this.filterMenuByRoute();
      });
    }
  }

  filterMenuByRoute() {
    let index1 = this.userDetails.filter((item: any) => {
      return item['Menu'].vRouterLink === this.href
    });
    this.aceessMenuByRoute = index1[0];
  }
}